import React, { useState, useEffect } from "react";
import "./Questions.scss";
import { useHistory } from "react-router";
import Drop from "../../assets/images/MobFavDrop.svg";
import Down from "../../assets/images/MobFavDown.svg";
import useWindowSize from "../../hooks/useWindowSize";
import Faq from "react-faq-component";

const data = {
  rows: [{
    title: "How do I log in and Sign Up ?",
    content: [
      `There are 2 ways to login and sign up into the Diagnostic Market Place To Login`,
      <br></br>,
      `1. Click on the Login button at the top right corner of the website, you will be required to input your registered phone number and 4 digit unique passcode.`,
      <br></br>,
      `2.Click on the Create an Account to sign up`,
      <br></br>,
      `3. Fill in your name, phone number and Email address and click continue.`,
      <br></br>,
      `4. An OTP will be sent to both your phone number and email. Click Create Account to complete the process. `,
      <br></br>,
      `5. You will then be required to login with your phone number and 4 digit unique passcode. `,
      <br></br>,
      <br></br>,
      `From Checkout Page
                     Upon completing your test selection, price comparison across the different partners and adding your selection to your cart, you would be required to login to your account or create an account as a new user, before proceeding to Checkout. 
                     Clicking the Proceed to Checkout launches the Login interface. Fill in your login credentials or complete the create an account process to complete your purchase
                     `,
    ],
  },
  {
    title: "How can I order a test ?",
    content: [
      `To order a test:`,
      <br></br>,
      `1. Click on the Shop Test Button on the landing page. This takes you to test page`,
      <br></br>,
      `2. Select what category of test you wish to buy; Radiology or Pathology `,
      <br></br>,
      `3. Set your Location (City and Area),`,
      <br></br>,
      `4. You can use the search box to search for your test using key words`,
      <br></br>,
      `5. You can also filter the test displayed by alphabet groups`,
      <br></br>,
      `6. Click on the Select test on each test card for your preferred test. Your selected test will be added to a Selection Screen`,
      <br></br>,
      `7. Click on the Compare Test Price when you have completed your selection `,
      <br></br>,
      `8. In the Compare test page, You can filter from the list of available laboratory partners `,
      <br></br>,
      `9. Each selected test is displayed under each partner, you can review each partner's price and make your selection.`,
      <br></br>,
      `10. You can click on the Home Sample Collection to opt for our home visit form your preferred partner or choose uncheck this option to visit the laboratory to have your sample collected `,
      <br></br>,
      `11. Click on Add to Cart to move your selection to the cart and on the cart, click on Proceed to Checkout `,
      <br></br>,
      `12. You will be required to Login or sign up to complete your purchase. `,
      <br></br>,
      `13. Select who you would be buying the test for, you can add multiple relatives to your selection. `,
      <br></br>,
      `14. Click on the proceed to checkout to make payment and complete your order. `,
      <br></br>,
      `15. An email confirmation and receipt will be sent to you once payment is made`,
      <br></br>,
      `16. Your selected Laboratory partner will contact an hour after payment is made to schedule your sample collection.`,
      <br></br>,
    ],
  },
  {
    title: "Do I need a doctor’s order before I can purchase tests ? ",
    content: [
      `No. After payment, you will be able to access  your order receipt that will suffice. However, you will also be required to fill out a partner's requisition form as per policy before sample collection. 
              `,
    ],
  },
  {
    title: "Can I buy a test for someone ?",
    content: [
      `Yes, you can. Simply  register the person's details  as a relative when making your order. There are 2 ways of adding a relative:`,
      <br></br>,

      `From Relative Page `,
      <br></br>,
      ` 1. Click on the Profile icon to open the available options and Click on Relatives `,
      <br></br>,
      ` 2. In Relatives Page Click on the Add Relative button and fill out all the information on the Add Relative Profile `,
      <br></br>,
      ` 3. Click on the Update Profile Button when all profile sections are completely filled.  All added relatives will be available when completing your checkout for any test. `,
      <br></br>,
      ` 4. On the Relative landing page Click on the Edit button to make changes or update relative information.`,
      <br></br>,
      ` 5.Click on the Delete button to remove a saved relative.`,
      <br></br>,

      `From Checkout Page `,
      <br></br>,
      ` 1. In the Add Test Recipient page, click on the Add New Relative Button, this launches the Add New Relative details interface.`,
      <br></br>,
      ` 2. Fill out all the input sections`,
      <br></br>,
      ` 3. Click on the Add Relative to save details. You can repeat this process multiple times for multiple relatives.`,
      <br></br>,
      ` 4. You can view and update all added relatives on the Relatives Page.`,
      <br></br>,
    ],
  },
  {
    title: "How do I get my test result online ? ",
    content: [
      `Electronic copy of your test result is available on your Diagnostic Marketplace My Orders and the mobile app. To view your test Results`,
      <br></br>,
      `On Diagnostic Marketplace`,
      <br></br>,
      `Click on the Login button at the top right corner of the website, you will be required to input your registered phone number and 4 digit unique passcode.`,
      <br></br>,
      ` 1. Once login is successful, click on the name profile to display the drop down options and select My Account. This takes you into the profile dashboard`,
      <br></br>,
      ` 2. On the side menu, click on Orders and Results - this page displays all your orders both completed and In-Progress.`,
      <br></br>,
      ` 3. Click on the check result icon to go into the order `,
      <br></br>,
      ` 4. Click on the View Result for the test under that order. The View result button will only be active once the Order Tracking status is set to Result Released.`,
      <br></br>,
      `On The Mobile App`,
      <br></br>,
      ` 1. Click on Health Records on the bottom mean and navigate to Lab Results Tab in Health Record`,
      <br></br>,
      ` 2. Your test results will be available in the order of the most recent result`,
      <br></br>,
      ` 3. You can also filter by date and by Service partner`,
      <br></br>,
    ],
  },
  {
    title: "Is home sample collection available ? ",
    content: [
      `Yes, home sample collection is available depending on the test and location. Once you have selected a test and proceed to compare prices, the option for home sample collection will be made available to select on each partner section. You will also be notified for selected tests that do not have home sample collection. 
              `,
    ],
  },
  ]
};

function Questions() {
  let history = useHistory()
  const [selection, setSelection] = useState("");
  const [ismoblie, setismobile] = useState(false);

  const [width, height] = useWindowSize();
  useEffect(() => {
    if (width && width <= 767)
      setismobile(true);
    else
      setismobile(false);
  }, [width])
  const scrollToFooter = () => {
    window.scrollTo(0, 6000);
  }
  const styles = {
    // bgColor: 'white',
    titleTextColor: "#163E8C",
    rowTitleColor: "#163E8C",
    rowContentColor: "#163E8C",
    rowContentTextSize: "16px",
    rowContentPaddingBottom: "10px",
    rowContentPaddingLeft: "50px",
    marginTop: "40px",
    // arrowColor: "red",
  };

  const config = {
    animate: true,
    tabFocus: true,
  };

  const phoneNumber = "+2349010996000";

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <div className="allpa">
      <div className="parentQuestions">
        <div className="parentQuestionsleft">
          <div className="asked">Frequently asked questions</div>
          <div className="asked2">
            Can’t find the answer you’re looking for? Reach
            out to our&nbsp;<span onClick={handleWhatsAppClick} style={{ cursor: "pointer" }}>customer support</span>  team.
          </div>
          {/* <div className="asked3" onClick={() => scrollToFooter()}> */}
          <div className="asked3" onClick={() => history.push("/faq")}>
            View more questions
            {/* <a
              style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
              href='#footer123'
              target="_blank"
              rel="noreferrer"
              className="asked3"
            >
              View more questions
            </a> */}
          </div>


        </div>

        {/* <div className="parentQuestionsright">
          <div className="startque">
            <div className="ques1" onClick={() => { setSelection(selection == "q1" ? "" : "q1") }}><b><div>When should I take my test?</div></b> {ismoblie && (selection == "q1" ? <img src={Down} /> : <img src={Drop} />) || ""}</div>
            {(!ismoblie || selection == "q1") && <div className="answer">
              Returning your sample immediately ensures your sample reaches the
              lab before the weekend and avoids any delays in testing.
              <div style={{ marginTop: "26px" }}>
                If it is your first time collecting your sample, we recommend
                giving yourself at least 30 minutes to ensure you have read
                through the step-by-step instructions and are well prepared.
              </div>
            </div> || ""}
          </div>

          <div className="startque">
            <div className="ques1" onClick={() => { setSelection(selection == "q2" ? "" : "q2") }}><div><b>When should I take my STI test?</b></div> {ismoblie && (selection == "q2" ? <img src={Down} /> : <img src={Drop} />) || ""}</div>
            {(!ismoblie || selection == "q2"
            ) && <div className="answer">
                I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.
              </div> || ""}
          </div>

          <div className="startque">
            <div className="ques1" onClick={() => { setSelection(selection == "q3" ? "" : "q3") }}><div><b>Do I have to fast before a test?</b></div> {ismoblie && (selection == "q3" ? <img src={Down} /> : <img src={Drop} />) || ""}</div>
            {(!ismoblie || selection == "q3") && <div className="answer">
              Nobody knows. Lorem ipsum dolor sit amet consectetur adipisicing
              elit. Quas cupiditate laboriosam fugiat.
            </div> || ""}
          </div>

          <div className="startque">
            <div className="ques1" onClick={() => { setSelection(selection == "q4" ? "" : "q4") }}><div><b>Do I need a  prescription to order?</b></div> {ismoblie && (selection == "q4" ? <img src={Down} /> : <img src={Drop} />) || ""}</div>
            {(!ismoblie || selection == "q4") && <div className="answer" style={{ marginBottom: "31px" }}>
              Because they're so good at it. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.
            </div> || ""}
          </div>
        </div> */}
        <div >
          <div className="FAQ-align1">
            <Faq data={data} styles={styles} config={config} />
          </div>
        </div>
      </div>

    </div >
  );
}

export default Questions;
